import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { getProperty, getPropertyImages } from "../utils/api";

function PropertyDetails({ setBanner }) {
  const { id } = useParams(); // ✅ property ID from route
  const navigate = useNavigate();
  const [property, setProperty] = useState(null);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    if (id) {
      Promise.all([getProperty(id), getPropertyImages(id)])
        .then(([propRes, imgRes]) => {
          if (propRes?.success) {
            setProperty(propRes.property || null);
          } else {
            setBanner?.({
              type: "danger",
              message: propRes?.message || "Failed to load property details.",
            });
          }

          if (Array.isArray(imgRes)) {
            setImages(imgRes);
          } else if (imgRes?.success) {
            setImages(imgRes.images || []);
          }
        })
        .catch((err) => {
          console.error("Error fetching property details:", err);
          setBanner?.({
            type: "danger",
            message: "Error fetching property details.",
          });
        })
        .finally(() => setLoading(false));
    }
  }, [id, setBanner]);

  const handleBack = () => {
    const from = location.state?.from || "listings"; // default to listings
    navigate("/", { state: { scrollTo: from } });
  };

  if (loading) {
    return <p className="text-muted">Loading property details...</p>;
  }

  if (!property) {
    return <p className="text-danger">Property not found.</p>;
  }

  return (
    <div className="container mt-5 pt-4">
      <button className="btn btn-secondary mb-3" onClick={handleBack}>
        ← Back to{" "}
        {location.state?.from === "featured" ? "Featured" : "Listings"}
      </button>

      <h2>{property.title || "Untitled Property"}</h2>
      <p>
        <strong>Location:</strong>{" "}
        {property.location || "Location not specified"}
      </p>
      <p>
        <strong>Price:</strong> PHP {property.price || "N/A"}
      </p>
      <p>
        <strong>Description:</strong>{" "}
        {property.description || "No description available"}
      </p>

      {images.length > 0 ? (
        <div
          id="propertyCarousel"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          <div className="carousel-inner">
            {images.map((img, idx) => (
              <div
                key={img.id || idx}
                className={`carousel-item ${idx === 0 ? "active" : ""}`}
              >
                {img.src ? (
                  <img
                    src={img.src}
                    className="d-block w-100 property-detail-image"
                    alt={
                      property.title
                        ? `${property.title} view ${idx + 1}`
                        : `Property view ${idx + 1}`
                    }
                  />
                ) : (
                  <div className="d-block w-100 bg-light text-center p-5 text-muted">
                    No Image
                  </div>
                )}
              </div>
            ))}
          </div>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#propertyCarousel"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon"></span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#propertyCarousel"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon"></span>
          </button>
        </div>
      ) : (
        <p className="text-muted">No images available for this property.</p>
      )}
    </div>
  );
}

export default PropertyDetails;
